import * as Types from '../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type SignInFlowFragmentFragment = { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> };

export type SignInFlowQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SignInFlowQuery = { __typename?: 'Query', signInFlow: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } };

export const SignInFlowFragmentFragmentDoc = gql`
    fragment SignInFlowFragment on SignInFlowState {
  id
  initialStep {
    id
    name
    status
  }
  steps {
    id
    name
    status
    isBlocking
  }
  hasBlockingStep
}
    ` as unknown as DocumentNode<SignInFlowFragmentFragment, unknown>;
export const SignInFlowDocument = gql`
    query signInFlow {
  signInFlow {
    ...SignInFlowFragment
  }
}
    ${SignInFlowFragmentFragmentDoc}` as unknown as DocumentNode<SignInFlowQuery, SignInFlowQueryVariables>;